/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { parsers } from '@codegrade/utils';
import { BaseCouponUsage } from './BaseCouponUsage';
import { CourseOfTenantCouponUsage } from './CourseOfTenantCouponUsage';
import { TenantCoupon } from './TenantCoupon';
const TenantCouponUsageParser = 
/* #__PURE__ */ /* #__PURE__ */ codec.intersect(
/* #__PURE__ */ parsers.object([
    ['scope', /* #__PURE__ */ parsers.exactly('tenant')],
    ['coupon', TenantCoupon],
    ['course', CourseOfTenantCouponUsage],
]), BaseCouponUsage);
export class TenantCouponUsage extends BaseCouponUsage {
    static decode(input) {
        return TenantCouponUsageParser.decode(input).map(res => new TenantCouponUsage(res));
    }
    static unsafeDecode(input) {
        return TenantCouponUsage.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return TenantCouponUsageParser.encode(data);
    }
    static schema() {
        return TenantCouponUsageParser.schema();
    }
}
